// import { React, useState, useEffect, useContext, createContext } from "react";
// import { Navigate } from "react-router-dom";


// const AuthContext = createContext(null);
// export const PrivateRoute = ({ children }) => {
//   const [isAuthenticated, setIsAuthenticated] = useState(null); // null пока статус не известен
//   const token = localStorage.getItem('token'); // Берем токен из localStorage

//   useEffect(() => {
//     const validateToken = async () => {
//       if (!token) {
//         setIsAuthenticated(false); // Если токена нет, пользователь не авторизован
//         return;
//       }

//       try {
//         const response = await fetch('http://91.186.196.251:8081/api/validate-token', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${token}`, // Передаем токен в заголовке
//           },
//         });

//         if (response.ok) {
//           setIsAuthenticated(true); // Если ответ успешный, токен действителен
//           const userData = await response.json()
//           await localStorage.setItem("user", JSON.stringify(userData))
          
          
//         } else {
//           setIsAuthenticated(false); // Если сервер вернул ошибку, токен недействителен
//         }
//       } catch (error) {
//         console.error('Error validating token:', error);
//         setIsAuthenticated(false); // В случае ошибки считаем, что токен недействителен
//       }
//     };

//     validateToken();
//   }, [token]);

//   if (isAuthenticated === null) {
//     // Пока идет проверка токена, можно показывать индикатор загрузки
//     return <div>Loading...</div>;
//   }

//   return isAuthenticated ? children : <Navigate to="/login" />;
// };

import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthProvider";

export const PrivateRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated === null) {
    // Пока идет проверка токена
    return <div>Loading...</div>;
  }

  return isAuthenticated ? children : <Navigate to="/login" />;
};